import distanceGradient from 'images/year-in-review/2017/icons/personal-distance.png'
import workoutsLight from 'images/year-in-review/2017/icons/personal-workouts-light.png'
import workoutsGradient from 'images/year-in-review/2017/icons/personal-workouts-gradient.png'
import durationGradient from 'images/year-in-review/2017/icons/personal-duration.png'
import energyLight from 'images/year-in-review/2017/icons/personal-energy-light.png'
import energyGradient from 'images/year-in-review/2017/icons/personal-energy-gradient.png'

const icons = {
  distanceGradient,
  workoutsLight,
  workoutsGradient,
  durationGradient,
  energyLight,
  energyGradient,
}
export default icons



// WEBPACK FOOTER //
// ./src/components/yearInReview/2017/Personal/personalIcons.js